import React, { forwardRef } from "react";
import styled, { useTheme } from "styled-components";
import { LinkedinIcon } from "react-share";
import IStyledProps from "../../utilities/IStyledProps";
import IEditableProps from "../../utilities/IEditableProps"
import classNames from "classnames";

const AuthorContainer = styled.div`
   a {
       text-decoration: none;
       margin-top: 2px;
   }

   a:hover {
       text-decoration: underline;
   }
`;

export interface IAuthorProps extends IStyledProps, IEditableProps {
    name: string;
    title?: string;
    linkedIn?: string;
    children?: any;
}

const Author = forwardRef((props: IAuthorProps, ref: any) => {
    const { name, title, linkedIn, children, editorClassObj, cmsId } = props;
    const theme = useTheme();

    function validateUrlProtocol(url) {
        if (/^http(s?):\/\//i.test(url)) {
            return url;
        } else {
            return `https://${url}`;
        }
    }

    return (
        <AuthorContainer data-id={cmsId} className={classNames(editorClassObj, "row mt-5 px-1 px-lg-3")} ref={ref}>
            <div className="col-12 px-0">
                <div className="name float-left">
                    <strong className="h6">{name}</strong>
                </div>
                {linkedIn ?
                    <a href={`${validateUrlProtocol(linkedIn)}`} target="_blank" rel="noopener noreferrer" className="ml-2">
                        <LinkedinIcon size={20} round={false} bgStyle={{ fill: theme.primary }} />
                    </a>
                    :
                    null
                }
            </div>
            {title &&
                <div className="col-12 font-italic text-muted px-0">
                    <small>{title}</small>
                </div>
            }
            {children &&
                <div className="col-4 mt-3 text-muted px-0">
                    <small>{children}</small>
                </div>
            }
        </AuthorContainer>
    );
});

export default Author;
(global as any).Author = Author;
